<div class="sidebar">
  <div class="menu main">
    <div class="item-link">
      <a
        (click)="onNavToDashBoard()"
        [routerLink]="['/dashboard']"
        routerLinkActive="active"
      >
        <div class="widgets"></div>
      </a>
    </div>
  </div>
  <mat-divider style="margin-bottom: 16px"></mat-divider>
  <ng-container *ngFor="let module of menu; let i = index">
    <app-submenu
      *ngIf="module.access"
      [module]="module"
      [index]="i"
    ></app-submenu>
  </ng-container>
</div>
